import React, { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Loader2, MessagesSquare } from "lucide-react";
import { Button } from "./ui/button";
import { Checkbox } from "./ui/checkbox";
import { startVerdant } from "../lib/api";
import VerdantPanel from "./VerdantPanel";

export default function VerdantCheck({ session, setSession, ackText }) {
  const key = `gf.verdant.${session.id}`;
  const saved = (() => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } })();
  const [agreed, setAgreed] = useState(!!saved);
  const [busy, setBusy] = useState(false);
  const [context, setContextState] = useState(saved);
  const setContext = (c) => {
    if (c) sessionStorage.setItem(key, JSON.stringify(c));
    else sessionStorage.removeItem(key);
    setContextState(c);
  };

  const start = async () => {
    setBusy(true);
    try {
      const r = await startVerdant(session.id);
      setSession({ ...session, verdant_ack: r.verdant_ack });
      setContext(r.context);
    } catch (ex) {
      toast.error(ex?.response?.data?.detail || "Could not open Ask Dr. Verdant.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="verdant-check" className="rounded-2xl bg-white border border-sky-200 p-5">
      <div className="flex items-center gap-2 text-sky-700 text-[11px] font-bold uppercase tracking-widest">
        <MessagesSquare size={14} /> Interactive follow-up &middot; included
      </div>
      <h3 className="font-display text-xl font-bold text-[#092C15] mt-1">Continue with Ask Dr. Verdant&trade;</h3>
      <p className="text-sm text-slate-600 mt-1">Your case details and photos are sent along with your chat, so you don't need to upload them again.</p>
      <p data-testid="verdant-ack-text" className="mt-3 rounded-xl bg-slate-50 border border-slate-200 p-3 text-xs leading-relaxed text-slate-600">{ackText}</p>
      <label className="mt-3 flex items-start gap-2.5 text-sm text-slate-700 cursor-pointer">
        <Checkbox data-testid="verdant-ack-checkbox" checked={agreed} onCheckedChange={(v) => setAgreed(v === true)}
          className="mt-0.5 data-[state=checked]:bg-sky-600 data-[state=checked]:border-sky-600" />
        I understand and agree to continue.
      </label>
      <Button data-testid="verdant-start-button" onClick={start} disabled={!agreed || busy}
        className="mt-4 w-full min-h-12 h-auto py-3 whitespace-normal rounded-xl bg-sky-600 hover:bg-sky-700 font-bold tracking-wide">
        {busy ? <Loader2 size={16} className="mr-2 animate-spin" /> : null} START YOUR INSTANT LANDSCAPE CHECK <ArrowRight size={18} className="ml-2" />
      </Button>
      {context && <VerdantPanel context={context} sessionId={session.id} onClose={() => setContext(null)} />}
    </section>
  );
}
